/**
 * <cart-upsell-carousel>
 * Native, jQuery-free scroll-snap carousel for the cart-drawer upsell.
 * One card per slide; prev/next arrows + dynamic dots that track scroll.
 * connectedCallback re-initialises cleanly on every AJAX drawer re-render.
 */
if (!customElements.get('cart-upsell-carousel')) {
  class CartUpsellCarousel extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.track = this.querySelector('[data-cart-upsell-track]');
      this.slides = Array.from(this.querySelectorAll('[data-cart-upsell-slide]'));
      this.dotsWrap = this.querySelector('[data-cart-upsell-dots]');
      this.prevBtn = this.querySelector('[data-cart-upsell-prev]');
      this.nextBtn = this.querySelector('[data-cart-upsell-next]');

      if (!this.track || this.slides.length <= 1) return;
      this.dataset.ready = 'true';

      this.buildDots();
      this.bindEvents();
      this.update();
    }

    gap() {
      const styles = getComputedStyle(this.track);
      return parseFloat(styles.columnGap || styles.gap || '12') || 12;
    }

    slideStep() {
      return this.slides[0].getBoundingClientRect().width + this.gap();
    }

    currentIndex() {
      return Math.round(this.track.scrollLeft / this.slideStep());
    }

    buildDots() {
      if (!this.dotsWrap) return;
      this.dotsWrap.innerHTML = '';
      this.dots = this.slides.map((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'cart-upsell__dot';
        dot.setAttribute('aria-label', 'Go to item ' + (i + 1));
        dot.addEventListener('click', () => this.goTo(i));
        this.dotsWrap.appendChild(dot);
        return dot;
      });
    }

    bindEvents() {
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.goTo(this.currentIndex() - 1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.goTo(this.currentIndex() + 1));
      this.track.addEventListener(
        'scroll',
        () => {
          if (this._raf) cancelAnimationFrame(this._raf);
          this._raf = requestAnimationFrame(() => this.update());
        },
        { passive: true }
      );
    }

    goTo(index) {
      const clamped = Math.max(0, Math.min(this.slides.length - 1, index));
      this.track.scrollTo({ left: clamped * this.slideStep(), behavior: 'smooth' });
    }

    update() {
      const index = this.currentIndex();
      if (this.dots) {
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      }
      if (this.prevBtn) this.prevBtn.disabled = index <= 0;
      if (this.nextBtn) this.nextBtn.disabled = index >= this.slides.length - 1;
    }
  }

  customElements.define('cart-upsell-carousel', CartUpsellCarousel);
}
